__turbopack_context__.v({
  "accent": "PlasmicToast-module__grRzaG__accent",
  "accentIcon": "PlasmicToast-module__grRzaG__accentIcon",
  "accentIcontype_error": "PlasmicToast-module__grRzaG__accentIcontype_error",
  "accentIcontype_success": "PlasmicToast-module__grRzaG__accentIcontype_success",
  "accentIcontype_warning": "PlasmicToast-module__grRzaG__accentIcontype_warning",
  "accenttype_error": "PlasmicToast-module__grRzaG__accenttype_error",
  "accenttype_success": "PlasmicToast-module__grRzaG__accenttype_success",
  "accenttype_warning": "PlasmicToast-module__grRzaG__accenttype_warning",
  "close": "PlasmicToast-module__grRzaG__close",
  "closeIcon": "PlasmicToast-module__grRzaG__closeIcon",
  "text": "PlasmicToast-module__grRzaG__text",
  "text___1U6ZH": "PlasmicToast-module__grRzaG__text___1U6ZH",
  "text__c2FXg": "PlasmicToast-module__grRzaG__text__c2FXg",
  "toast": "PlasmicToast-module__grRzaG__toast",
  "wrapper": "PlasmicToast-module__grRzaG__wrapper",
});
